import api from '../../utils/api'

export const state = {

}

export const mutations = {

}

export const actions = {
  async handleGetByRole(_, roleId) {
    try {
      return await api.get(`/sector-role/${roleId}/role`)
    } catch (err) {
      throw err
    }
  },
}

export const getters = {

}
